import React, { useState } from "react";
import "./FeeStructureStyles.css";
import Navbar from "../components/navbar";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";

// --- Custom Inline SVGs tailored to match the Reference Image icons ---
const GraduationCapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" className="fra-icon-svg">
    <path d="M12 3L1 9l11 6 9-4.91V17h2V9L12 3zM3.47 9L12 4.35 20.53 9 12 13.65 3.47 9z"/>
    <path d="M7 14.32V17c0 2.3 4.14 3.5 8 3.5s8-1.2 8-3.5v-2.68l-8 4.36-8-4.36z"/>
  </svg>
);

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <line x1="12" y1="16" x2="12" y2="12"></line>
    <line x1="12" y1="8" x2="12.01" y2="8"></line>
  </svg>
);

// Map of icons corresponding exactly to each card row item in your design
const CardIconMap = {
  1: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
      <path d="M6 12v5c0 2 2 3 6 3s6-1 6-3v-5"/>
    </svg>
  ),
  2: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="2" width="16" height="20" rx="2" ry="2"/>
      <line x1="9" y1="22" x2="9" y2="16"/>
      <line x1="15" y1="22" x2="15" y2="16"/>
      <line x1="9" y1="16" x2="15" y2="16"/>
      <path d="M8 6h2v2H8V6zm6 0h2v2h-2V6zm-6 4h2v2H8v-2zm6 0h2v2h-2v-2z"/>
    </svg>
  ),
  3: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 19h16v2H4zM19 5H5c-1.1 0-2 .9-2 2v9c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2z"/>
      <path d="M12 5V3"/>
    </svg>
  ),
  4: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
      <circle cx="12" cy="7" r="4"/>
    </svg>
  ),
  5: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/>
      <line x1="2" y1="12" x2="22" y2="12"/>
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
    </svg>
  ),
  6: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  )
};

const FEE_DATA = {
  english: {
    lblAmount: "Fee Amount",
    lblTotal: "Total Fees",
    columns: ["Sr. No.", "Description", "Fees (₹)", "Total Fees (₹)"],
    rows: [
      { id: 1, desc: "Tuition Fees", fee: "1,56,087", total: "1,82,500" },
      { id: 2, desc: "Development Fees", fee: "23,413", total: "Included in Tuition Fees" },
      { id: 3, desc: "Management / Institute Seat Fees", fee: "1,82,500", total: "1,82,500" },
      { id: 4, desc: "NRI Seat Fees", fee: "Not Applicable", total: "Not Applicable" },
      { id: 5, desc: "Against NRI Seat Fees", fee: "Not Applicable", total: "Not Applicable" },
      { id: 6, desc: "Caution Money / Deposit (Refundable)", fee: "3,000", total: "3,000" },
    ],
    noteText: "Note: All fees are in Indian Rupees (₹). Fees are subject to change as per institute / regulatory guidelines."
  },
  marathi: {
    lblAmount: "शुल्क रक्कम",
    lblTotal: "एकूण शुल्क",
    subTitle: "प्रथम वर्ष – मास्टर ऑफ़ कंप्यूटर एप्लीकेशन (एम. सी. ए.) अभ्यासक्रमासाठी शुल्क (शैक्षणिक वर्ष २०२६–२७)",
    columns: ["क्रमांक", "तपशील", "शुल्क (₹)", "एकूण शुल्क (₹)"],
    rows: [
      { id: 1, desc: "शिक्षण शुल्क", fee: "१,५६,०८७ /-", total: "१,८२,५००/-" },
      { id: 2, desc: "विकास शुल्क", fee: "२३,४१३ /-", total: "शिक्षण शुल्कात समाविष्ट" },
      { id: 3, desc: "मॅनेजमेंट / इन्स्टिट्यूट सीट शुल्क", fee: "१,८२,५००/-", total: "१,८२,५००/-" },
      { id: 4, desc: "एन.आर.आय. सीट शुल्क", fee: "लागू नाही", total: "लागू नाही" },
      { id: 5, desc: "अगेंस्ट एन.आर.आय. सीट शुल्क", fee: "लागू नाही", total: "लागू नाही" },
      { id: 6, desc: "सुरक्षा जमा शुल्क (परत करण्यायोग्य)", fee: "३,०००/-", total: "३,०००/-" },
    ],
    noteText: "टीप: सर्व शुल्क भारतीय रुपयात (₹) आहे. शुल्क संस्था / नियामक मार्गदर्शक तत्त्वांनुसार बदलू शकते."
  },
  hindi: {
    lblAmount: "शुल्क राशि",
    lblTotal: "कुल शुल्क",
    subTitle: "प्रथम वर्ष – मास्टर ऑफ़ कंप्यूटर एप्लीकेशन (एम.सी.ए.) पाठ्यक्रम हेतु शुल्क (शैक्षणिक वर्ष २०२६–२७)",
    columns: ["क्रमांक", "विवरण", "शुल्क (₹)", "कुल शुल्क (₹)"],
    rows: [
      { id: 1, desc: "शिक्षण शुल्क", fee: "१,५६,०८७ /-", total: "१,८२,५००/-" },
      { id: 2, desc: "विकास शुल्क", fee: "२३,४१३ /-", total: "शिक्षण शुल्क में शामिल" },
      { id: 3, desc: "मॅनेजमेंट / इन्स्टिट्यूट सीट शुल्क", fee: "१,८२,५००/-", total: "१,८२,५००/-" },
      { id: 4, desc: "एन.आर.आय. सीट शुल्क", fee: "लागू नहीं", total: "लागू नहीं" },
      { id: 5, desc: "अगेंस्ट एन.आर.आय. सीट शुल्क", fee: "लागू नहीं", total: "लागू नहीं" },
      { id: 6, desc: "सुरक्षा जमा शुल्क (प्रतिदेय शुल्क)", fee: "३,०००/-", total: "३,०००/-" },
    ],
    noteText: "नोट: सभी शुल्क भारतीय रुपये (₹) में हैं। शुल्क संस्थान / नियामक दिशानिर्देशों के अनुसार परिवर्तन के अधीन हैं."
  }
};
const FRAFeeStructure = () => {
  const [activeTab, setActiveTab] = useState("english");
  const currentContent = FEE_DATA[activeTab];

  // Utility to handle prefix rendering for monetary figures safely
  const formatCurrencyValue = (val) => {
    if (!val) return "—";
    if (val === "Not Applicable" || val === "NA" || val.includes("लागू") || val.includes("शामिल") || val.includes("समाविष्ट")) {
      return val;
    }
    return val.startsWith("₹") || val.startsWith("१") || val.startsWith("३") || val.startsWith("२") ? val : `₹${val}`;
  };

  return (
    <>
      <Navbar />
      <PageHeader
        title="FRA – Fee Structure"
        crumbs={[
          { label: "Home", href: "/" },
          { label: "FRA – Fee Structure" },
        ]}
      />
      <div className="fra-page-wrapper">
        <div className="fra-container">
          
          {/* Top Banner Accent */}
          <div className="fra-ay-banner-wrapper">
            <div className="fra-ay-banner">
              <GraduationCapIcon />
              <span>Academic Year: 2026–27</span>
            </div>
          </div>

          {/* Languages Selector Tabs - CHANGED TO USE UNIFIED DESKTOP/MOBILE CLASSES */}
          <div className="fra-tabs-wrapper">
            {['english', 'marathi', 'hindi'].map((lang) => (
              <button 
                key={lang}
                className={`fra-tab-btn ${activeTab === lang ? 'active' : ''}`}
                onClick={() => setActiveTab(lang)}
              >
                {lang.charAt(0).toUpperCase() + lang.slice(1)}
              </button>
            ))}
          </div>

          {/* Core Content Container Block */}
          <div className="fra-main-surface-card">
            <div className="fra-surface-card-header">
              <h2 className="fra-surface-card-title">
                {activeTab === 'english' 
                  ? "Final Fees for 1st Year – Master of Computer Application (MCA) Course for the AY 2026-27" 
                  : currentContent.subTitle}
              </h2>
            </div>
            
            {/* Desktop View: Pure Clean Table, Hidden completely on Mobile viewports */}
            <div className="fra-table-desktop-container">
              <table className="responsive-table">
                <thead>
                  <tr>
                    <th>{currentContent.columns[0]}</th>
                    <th>{currentContent.columns[1]}</th>
                    <th>{currentContent.columns[2]}</th>
                    <th>{currentContent.columns[3]}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentContent.rows.map((row, index) => (
                    <tr key={index}>
                      <td>{row.id}</td>
                      <td>{row.desc}</td>
                      <td style={{ fontWeight: 'bold' }}>{row.fee}</td>
                      <td>{row.total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile View: Dynamic Card list, automatically renders when viewport is narrow */}
            <div className="fra-cards-mobile-stack">
              {currentContent.rows.map((row, index) => (
                <div key={index} className="fra-mobile-data-card">
                  
                  <div className="fra-mobile-card-aside">
                    <div className="fra-mobile-card-index">{row.id}</div>
                    <div className="fra-mobile-card-icon-bubble">
                      {CardIconMap[row.id] || <GraduationCapIcon />}
                    </div>
                  </div>
                  
                  <div className="fra-mobile-card-body">
                    <h3 className="fra-mobile-card-heading">{row.desc}</h3>
                    
                    <div className="fra-mobile-card-meta-row">
                      <div className="fra-meta-data-chunk">
                        <span className="fra-meta-chunk-label">{currentContent.lblAmount}</span>
                        <span className="fra-meta-chunk-value value-dark-bold">
                          {formatCurrencyValue(row.fee)}
                        </span>
                      </div>
                      
                      <div className="fra-meta-data-chunk text-right-aligned">
                        <span className="fra-meta-chunk-label">{currentContent.lblTotal}</span>
                        <span className="fra-meta-chunk-value">
                          {formatCurrencyValue(row.total)}
                        </span>
                      </div>
                    </div>

                  </div>
                </div>
              ))}
            </div>

            {/* Structured Bottom Footnote matching original screenshot accent */}
            <div className="fra-mobile-legal-footnote">
              <div className="fra-footnote-icon-holder">
                <InfoIcon />
              </div>
              <div className="fra-footnote-text-holder">
                {currentContent.noteText}
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FRAFeeStructure;